var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalenderIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.34 5.591H3.81l.627 1.255h5.277z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.182 2.246V1.2H8.927v1.046H5.164V1.2H3.909v1.046H1.4V12.7h8.155a3.136 3.136 0 0 0 3.136-3.136V2.246zm1.254 7.318a1.88 1.88 0 0 1-1.881 1.882h-6.9V3.5h1.254v1.046h1.255V3.5h3.763v1.046h1.255V3.5h1.254z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalenderIcon);
export default ForwardRef;